export interface ICartonAttribute {
  carton_length?: { value?: number };
  carton_width?: { value?: number };
  carton_height?: { value?: number };
}

export class MathUtility {
  static cbm = (attribute: ICartonAttribute, qty: number): number =>
    ((attribute?.carton_length?.value || 0) / 100) *
    ((attribute?.carton_width?.value || 0) / 100) *
    ((attribute?.carton_height?.value || 0) / 100) *
    qty;

  static cbf = (attribute: ICartonAttribute, qty: number): number =>
    ((attribute?.carton_length?.value || 0) / 12) *
    ((attribute?.carton_width?.value || 0) / 12) *
    ((attribute?.carton_height?.value || 0) / 12) *
    qty;
}
